import type { CityConfig } from "@/pages/city-template/types";

export const plattsburghConfig: CityConfig = {
  city: "Plattsburgh",
  state: "New York",
  stateAbbr: "NY",
  slug: "plattsburgh",
  route: "/cities/plattsburgh",
  title: "Emergency & Expedited Passport Plattsburgh NY | Same Day Passport Plattsburgh",
  metaDescription:
    "Emergency passport Plattsburgh NY — same day, 24-hour, and 3-5 day expedited passport processing for Clinton County. Fast Passport Center serves Plattsburgh, Peru, Morrisonville, and all North Country communities near Lake Champlain.",
  h1: "Emergency & Expedited Passport Services in Plattsburgh, NY",
  heroSubtitle:
    "Plattsburgh's fast passport solution — from the shores of Lake Champlain to the Canadian border. Whether you're flying out of Plattsburgh International or Burlington, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Plattsburgh%20New%20York%20downtown%20with%20historic%20buildings%20along%20Lake%20Champlain%20shoreline%2C%20SUNY%20Plattsburgh%20campus%20visible%2C%20green%20Adirondack%20mountains%20in%20background%2C%20warm%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20North%20Country%20upstate%20New%20York%20landscape%20with%20lake%20and%20mountains&width=1600&height=700&seq=ny-plattsburgh-hero-001&orientation=landscape",
  heroImageAlt: "Plattsburgh New York downtown with Lake Champlain and Adirondack Mountains",
  geoPosition: "44.6995; -73.4529",
  geoPlacename: "Plattsburgh, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~300 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Plattsburgh", zips: "12901, 12903, 12905" },
    { name: "Peru", zips: "12972" },
    { name: "Morrisonville", zips: "12962" },
    { name: "Champlain", zips: "12919" },
    { name: "Rouses Point", zips: "12979" },
    { name: "Mooers", zips: "12958" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Saranac Lake", zips: "12983" },
    { name: "Lake Placid", zips: "12946" },
    { name: "Ticonderoga", zips: "12883" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Burlington VT", zips: "05401-05408, 05495" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Plattsburgh travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Plattsburgh residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Clinton & North Country Region",
      desc: "Plattsburgh, Peru, Morrisonville, and the entire North Country — we serve all of northeastern New York from the Champlain Valley to the Adirondacks.",
    },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Peru, NY",
      rating: 5,
      text: "Had a last-minute trip to Montreal for a family emergency. Fast Passport Center got my emergency passport processed in 3 days. They handled everything from Plattsburgh.",
      service: "Emergency Passport",
    },
    {
      name: "Robert K.",
      location: "Plattsburgh, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4 days. Great service for us up here in the North Country.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah T.",
      location: "Morrisonville, NY",
      rating: 5,
      text: "First-time passport for my daughter heading to study abroad in Europe. The agent walked us through the entire process. Processed in 5 days with no issues.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "plattsburgh-1",
      name: "Plattsburgh Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "4245 Highway 9",
      city: "Plattsburgh",
      state: "NY",
      zip: "12901",
      phone: "518-561-5580",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Plattsburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Plattsburgh passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "plattsburgh-2",
      name: "Peru Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "3034 Route 22",
      city: "Peru",
      state: "NY",
      zip: "12972",
      phone: "518-643-2520",
      hours: "Mon-Fri 9:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Peru (south of Plattsburgh)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Peru and south Plattsburgh residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "plattsburgh-3",
      name: "Morrisonville Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "6240 State Route 9",
      city: "Morrisonville",
      state: "NY",
      zip: "12962",
      phone: "518-643-8224",
      hours: "Mon-Fri 9:00 AM - 4:00 PM",
      distance: "Morrisonville (west of Plattsburgh)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Morrisonville and western Plattsburgh communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Plattsburgh?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Plattsburgh residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Plattsburgh?",
      a: "The Plattsburgh Main Post Office at 4245 Highway 9 is the major Plattsburgh passport acceptance facility. The Peru Post Office at 3034 Route 22 and Morrisonville Post Office at 6240 State Route 9 are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Plattsburgh?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and Rite Aid locations throughout Plattsburgh and Clinton County. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Plattsburgh?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Plattsburgh passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Plattsburgh?",
      a: "The fastest way to renew a passport in Plattsburgh is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Plattsburgh?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Plattsburgh and all Clinton County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Plattsburgh?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Plattsburgh. We serve the North Country and all of Clinton County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Plattsburgh", address: "various CVS locations across Plattsburgh and Clinton County", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Plattsburgh", address: "various Walgreens locations throughout Plattsburgh", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Plattsburgh", address: "various Rite Aid locations in Plattsburgh and Peru", hours: "Mon-Sun, hours vary by location" },
    { name: "Walmart Photo Center — Plattsburgh", address: "Walmart Supercenter, Plattsburgh", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Plattsburgh",
      address: "5639 Route 9, Plattsburgh, NY 12901",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Plattsburgh DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Champlain",
      address: "1144 State Route 11, Champlain, NY 12919",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Champlain DMV office serving northern Clinton County and Canadian border communities.",
      featured: false,
    },
    {
      name: "NYS DMV — Peru",
      address: "3039 Main Street, Peru, NY 12972",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Peru DMV office serving south Plattsburgh and Peru area residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PBG",
      name: "Plattsburgh International Airport",
      distance: "In Plattsburgh, NY",
      address: "213 Connecticut Road, Plattsburgh, NY 12903",
      note: "Plattsburgh's primary airport with flights to Florida and other domestic destinations. Formerly an Air Force base, now a convenient option for North Country travelers.",
      flightUrl: "https://www.flyplattsburgh.com/",
      flightLabel: "PBG Airport",
      featured: true,
    },
    {
      code: "BTV",
      name: "Burlington International Airport",
      distance: "~35 miles from Plattsburgh",
      address: "1200 Airport Drive, South Burlington, VT 05403",
      note: "Vermont's largest airport with flights to major U.S. hubs including Chicago, New York, and Washington DC. Popular alternative for Plattsburgh area travelers.",
      flightUrl: "https://www.btv.aero/",
      flightLabel: "Burlington Airport",
      featured: false,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~155 miles from Plattsburgh",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's major airport with flights to destinations nationwide. Alternative for Plattsburgh travelers needing more flight options.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Plattsburgh travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Plattsburgh residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Plattsburgh residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Plattsburgh residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Plattsburgh, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Plattsburgh residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Plattsburgh travelers with immediate departure needs from Plattsburgh International or Burlington." },
    { name: "Passport Renewal", description: "Fast passport renewal for Plattsburgh residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Plattsburgh residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Plattsburgh residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Plattsburgh and Clinton County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Plattsburgh." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Plattsburgh travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Plattsburgh travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Plattsburgh team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Plattsburgh address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Plattsburgh and all of the North Country as a remote courier service. We do not have a physical office in Plattsburgh, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Plattsburgh area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Plattsburgh and all of Clinton County. From the shores of Lake Champlain to the Adirondack foothills, from Peru to Champlain — we serve the North Country with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Plattsburgh and all surrounding communities across Clinton County and the North Country region. Whether you're in Peru, Morrisonville, or Champlain, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Plattsburgh customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Plattsburgh travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Plattsburgh travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Plattsburgh. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default plattsburghConfig;